export default {
    aws_account: 'AWS Accounts',
    aws_invoice: 'AWS Invoices',
    aws_contracts: 'AWS Contracts',
    status: 'Status',
    aws_account_id: 'AWS Account ID',
    aws_account_name: 'AWS Account Name',
    discount_rate: 'Discount rate',
    reg_date: 'Reg date',
    placeholder_search: 'AWS account id,  AWS account name',
    discount_from: 'Discount from',
    cost_explorer: 'Cost explorer',
    others: 'Others',
    total_costs: 'Total costs',
    total_cost: 'Total cost',
    average_daily_cost: 'Average daily cost',
    average_cost: 'Average {granularity} cost',
    dimension_count: '{dimensionGroupName} count',
    cost_breakdown: 'Cost and usage breakdown',
    total: 'Total',
    clear_filter: 'Clear filter',
    date_range: 'Date Range',
    granularity: 'Granularity',
    group_by: 'Group By',
    filter: {
        today: 'Today',
        last_7_days: '7 Days',
        this_month: 'This Month',
        last_month: 'Last Month',
        last_2_months: 'Last 2 Months',
    },
    group: {
        service: 'Service',
        linked_account: 'Linked account',
        region: 'Region',
        instance_type: 'Instance type',
        usage_type: 'Usage type',
        charge_type: 'Charge type',
    },
    date_type: {
        daily: 'Daily',
        monthly: 'Monthly',
    },
    chart_types: {
        stack: 'Stack',
        bar: 'Bar',
    },
    invoices_unpaid: 'There are a few invoices that need to pay',
    only_show_unpaid: 'Only Show Unpaid Invoices',
    costs: 'Costs ({currencyCode})',
    billing_detail: 'Billing Detail',
    aws_billing_detail: 'AWS Billing Detail',
    estimated_bill_summary: {
        title: 'Estimated Bill Summary',
        bill_summary: 'Bill Summary',
        estimated_grand_total: 'Estimated Grand Total',
        grand_total: 'Grand Total',
        aws_inc: 'Amazon Web Services, Inc',
        aws_marketplace: 'Amazon Web Services, Inc. - Marketplace',
        billing_info: 'Billing Information',
        account_id: 'Account ID',
        billing_period: 'Billing Period',
        invoice_status: 'Invoice Status',
    },
    usage_quantity: 'Usage Quantity',
    charges_by_service: 'Amazon Web Services, Inc. charges by service',
    marketplace_charges_by_service:
        'Amazon Web Services, Inc. - Marketplace charges by service',
    total_active_services: 'Total Active Services',
    total_charge: 'Total Charge',
    bill_issued: 'Bill Issued',
    date_printed: 'Date Printed',
    aws_bill_summary: 'AWS Bill Summary',
    service_provider: 'Service Provider',
};
